import React, { Fragment, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Packages
import { Button, Container, Form, Modal, Spinner } from 'react-bootstrap';
import Lottie from 'lottie-react';
import PropTypes from 'prop-types';

// Components
import SelectButton from '../../../utils/SelectButton';
import Alert from '../../../utils/Alert';

// Actions
import { global_config_create } from '../../../../actions/globalActions';

// Utils
import errorExists from '../../../../utils/errorExists';

// Icons
import checkAnimation from '../../../../static/icons/checkAnimation.json';

const GlobalConfigForm = (props) => {
	const { show, onHide, filters } = props;

	const dispatch = useDispatch();

	const { organizations } = useSelector(state => state.organization);

	const { all_apps } = useSelector(state => state.apps);

	const { all_languages } = useSelector(state => state.languages);

	const { global_config_create_loading, global_config_create_success, global_errors } = useSelector(state => state.global);

	const initialAlert = { display: false, type: '', msg: '' };
	const [alert, setAlert] = useState(initialAlert);

	const initialGlobalConfigInfo = { organization: '', app: '', language: '' };
	const [globalConfigInfo, setGlobalConfigInfo] = useState(initialGlobalConfigInfo);

	const closeModalRef = useRef();
	const lottieRef	= useRef();

	const closeModal = () => {
		onHide();
		setGlobalConfigInfo(initialGlobalConfigInfo);
	}

	const validateGlobalConfigInfo = globalConfigInfo.organization === '' || globalConfigInfo.app === '' || globalConfigInfo.language === '';

	const createGlobalConfig = () => {		
		if (validateGlobalConfigInfo) {
			setAlert({ display: true, type: 'danger', msg: 'Missing fields!' });
			return;
		}
		setAlert(initialAlert);

		dispatch(global_config_create(globalConfigInfo, closeModalRef, filters));
	}

	return (
		<Modal
			show={show}
			onHide={closeModal}
			backdrop='static'
			keyboard={false}
			size='lg'
			aria-labelledby='contained-modal-title-vcenter'
			centered
		>
			<Modal.Header closeButton>
				<Modal.Title>Create Global Configuration</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{alert.display && <Alert type={alert.type} msg={alert.msg} />}
				
				{errorExists(global_errors, 'global_config_create') &&
					<Alert type='danger' msg={global_errors['global_config_create'].msg} />
				}

				<Form>
					<Container className='mb-3 p-0' fluid>
						<p className='mb-2'>Organization</p>
						<SelectButton
							options={organizations}
							name='organization'
							value={globalConfigInfo.organization}
							onChange={(e) => setGlobalConfigInfo({ ...globalConfigInfo, organization: e ? e.value : null })}
						/>
					</Container>
					<Container className='mb-3 p-0' fluid>
						<p className='mb-2'>App</p>
						<SelectButton
							options={all_apps}
							name='app'
							value={globalConfigInfo.app}
							onChange={(e) => setGlobalConfigInfo({ ...globalConfigInfo, app: e ? e.value : null })}
						/>
					</Container>
					<Container className='mb-3 p-0' fluid>
						<p className='mb-2'>Language</p>
						<SelectButton
							options={all_languages}
							name='language'
							value={globalConfigInfo.language}
							onChange={(e) => setGlobalConfigInfo({ ...globalConfigInfo, language: e ? e.value : null })}
						/>
					</Container>
				</Form>
			</Modal.Body>
			<Modal.Footer>
				<Button variant='outline-secondary' onClick={closeModal} ref={closeModalRef}>Cancel</Button>
				<Button 
					className={global_config_create_success ? 'success-btn' : 'submit-btn'}
					onClick={createGlobalConfig}
				>
					{global_config_create_success
						?	<Lottie
								loop={false}
								lottieRef={lottieRef}
								animationData={checkAnimation}
								style={{ height: '24px' }}
							/>
						:	global_config_create_loading
							?	<Fragment>
									<Spinner className='me-2' as='span' animation='border' size='sm' role='status' aria-hidden='true' />
									Creating
								</Fragment>
							:	'Create'
					}
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

GlobalConfigForm.propTypes = {
	show: PropTypes.bool.isRequired,
	onHide: PropTypes.func.isRequired,
	filters: PropTypes.object.isRequired
}

export default GlobalConfigForm;
